import React from 'react';
import styled from 'styled-components';

import { Admin } from '@/types/admin';
import { Organization } from '@/types/organization';
import { FormatError } from '@/services/api';
import { getFullName } from '@/utils/name';
import { LoginMenuContainer } from '../Container/LoginMenuContainer';
import { AnnouncementContainer } from '../Container/AnnouncementContainer';
import { LogoContents } from './LogoContents';

export type Props = {
  me: Admin;
  currentOrganization: Organization;
  isLoggedIn: boolean;
  unreadCount: number;
  markArticlesAsRead: () => void;
  error: FormatError<any>;
  language: string;
};

export const AppHeader: React.FC<Props> = ({
  me,
  currentOrganization,
  isLoggedIn,
  unreadCount,
  markArticlesAsRead,
  error,
  language,
}) => (
  <Wrapper>
    <StyledMenu>
      <LogoContents language={language} />
      <RightMenu>
        {isLoggedIn && (
          <AdminInfo>
            <AdminItem>{currentOrganization.corporationOfficialName}</AdminItem>
            <AdminItem>
              {currentOrganization.gloplaId
                ? `[${currentOrganization.gloplaId}]`
                : ''}
            </AdminItem>
            <AdminItem>{getFullName(me.firstName, me.lastName)}</AdminItem>
          </AdminInfo>
        )}
        <AnnouncementContainer
          unreadCount={unreadCount}
          markArticlesAsRead={markArticlesAsRead}
        />
        {isLoggedIn && (
          <LoginMenuContainer error={error} isLoggedIn={isLoggedIn} />
        )}
      </RightMenu>
    </StyledMenu>
  </Wrapper>
);

const Wrapper = styled.header`
  & + * {
    margin-top: 56px;
  }
`;

const StyledMenu = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 101;
  display: flex;
  min-height: 56px;
  background: #fff;
  border: none;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
`;

const RightMenu = styled.div`
  display: flex;
  margin-left: auto;
`;

const AdminInfo = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  padding-right: 24px;

  @media (max-width: 780px) {
    padding-right: 0px;
    flex-direction: column;
  }
`;

const AdminItem = styled.span`
  padding: 0 4px;
  color: rgba(51, 51, 51, 0.6);
  text-wrap: nowrap;
`;
